// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__L8BA+","item":"Tabs_item__YdGOI","select":"Tabs_select__7h6Ma","canHover":"Tabs_canHover__bQI9m"};